import { mapActions } from 'vuex';
import { STATUS, isPuzzleStatusCompleted } from '../components/PuzzleModel';

export default {
  computed: {
    puzzleStatusForReadOnly() {
      if (this.model && this.model.status) {
        return this.model.status;
      }

      const storePuzzle = this.$store.state.puzzle.puzzle;
      const routePuzzleId = this.$route?.params?.puzzleId;

      if (!routePuzzleId) {
        return STATUS.DRAFT;
      }

      if (storePuzzle && String(storePuzzle.id) === String(routePuzzleId)) {
        return storePuzzle.status;
      }

      return STATUS.DRAFT;
    },
    isReadOnly() {
      return isPuzzleStatusCompleted(this.puzzleStatusForReadOnly);
    },
  },
  methods: {
    ...mapActions(['activeAlert']),
    guardPuzzleMutation({ silent = false } = {}) {
      if (!this.isReadOnly) return true;

      if (!silent) {
        this.activeAlert({
          message: this.$t('puzzle.alert.readOnly'),
          theme: 'warning',
        });
      }

      return false;
    },
  },
};
